import React, { useEffect, useState } from "react";
import { DataGrid, GridApi, GridColDef, GridEventListener, GridEvents, GridRenderCellParams, GridRowEditStopParams, GridRowId, GridRowModel, GridRowParams, GridToolbarContainer, GridToolbarFilterButton, GridValueGetterParams, MuiEvent, useGridApiMethod, useGridApiRef } from '@mui/x-data-grid';
import { Box, Button, IconButton, Link, SelectChangeEvent } from "@mui/material";
import { taxesandfeesModel } from "../../models/TaxesAndFeesModel";
import { config } from "../../Constants";
import { AddEditTaxesAndFees } from "../AddEdit/AddEditTaxesAndFees";
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import useAuth from "../../context/AuthProvider";
import moment from "moment";
import HomeIcon from '@mui/icons-material/Home';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { TaxScheduleByJurisdictionModel } from "../../models/TaxScheduleByJurisdiction";
import { date } from "yup";
import { AddEdittaxScheduleByJurisdiction } from "../AddEdit/AddEdittaxScheduleByJurisdiction";
import { RiExpandUpDownLine } from "react-icons/ri";
import { apiClient } from "../../helper/api";
interface Iprops {
    taxesandfessCL: TaxScheduleByJurisdictionModel[],
    fetchData: () => void
}

export const TaxScheduleByJurisdictionList: React.FC<Iprops> = ({ taxesandfessCL, fetchData }) => {
    // const [loading, setloading] = useState(false);
    const { user } = useAuth();
    const token = user?.token;

    const initialLBData: TaxScheduleByJurisdictionModel = {
        taxCode: "",
        taxingJurisdiction: "",
        jurisdictionCode: "",
        rateType: 0,
        rate: 0,
        minTaxFee: 0,
        zipCode: "",
        lobid: 0,
        stateId: 0,
        dateCreated: new Date,
        dateModified: new Date,
        isDeleted: false,
        
        
    }

    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const goBack = () => {
        navigate(-1);
    }

    const [Open, setOpen] = React.useState(false);
    const [Formdata, setFormData] = React.useState(initialLBData);

    const handleClose = () => {
        setFormData(initialLBData);

        setOpen(false);
    };
    const handleSubmit = () => {
        fetchData();
        setOpen(false);
    };
    const handleClickOpen = () => {

        setFormData(initialLBData);
        setOpen(true);
    };
    const initialdata = { id: 0, businessCode: "" };
    const [LineOfBusiness, setLineOfBusiness] = useState([initialdata]);

    function fetchLOBData(sateid: string) {
        apiClient(`/LineOfBusiness/getLineOBusinessByStateId?stateId=${sateid}`, {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }),
        })
            .then((responseJson) => {
                if (!responseJson) return
                // Do something with the response
                if (responseJson.data != null) {
                    setLineOfBusiness(responseJson.data);
                }
            })
    };


    const handleEdit = (ILobData: TaxScheduleByJurisdictionModel) => {
        setLoading(true);
        console.log("handleEit", ILobData);
        let a: TaxScheduleByJurisdictionModel = {
            lobid: ILobData.lobid,
            stateId: ILobData.stateId,
            taxScheduleByJurisdictionId: ILobData.taxScheduleByJurisdictionId,
            taxCode: ILobData.taxCode,
            taxingJurisdiction: ILobData.taxingJurisdiction,
            jurisdictionCode: ILobData.jurisdictionCode,
            rateType: ILobData.rateType,
            rate: ILobData.rate,
            minTaxFee: ILobData.minTaxFee,
            zipCode: ILobData.zipCode,
            isDeleted: ILobData.isDeleted
        }

        fetchLOBData(ILobData.stateId?.toString() ?? "");




        setFormData(a);
        setOpen(true);
    };


    const handleDelete = (id: number) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            // icon: null, // Remove the icon property
            iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            showCancelButton: true,
            confirmButtonColor: '#02A4E3',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Delete',
            customClass: {
                confirmButton: 'btn-radius',
                cancelButton: 'btn-radius',
                popup: 'card-radius'
            }
        })
            .then((result) => {
                if (result.isConfirmed) {
                    apiClient("/TaxScheduleByJurisdiction/Delete?id=" + `${id}`,
                        {
                            headers: new Headers({
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`,
                            }),
                            method: "Delete",
                        }
                    )
                        .then((res) => {
                            if (!res) return
                            Swal.fire(
                                'Deleted!',
                                'Your file has been deleted.',
                                'success'
                            )
                            fetchData();
                            setOpen(false);
                        })
                  
                }
            })
        //call api to save data
        // fetch(config.url.API_URL + "/Users/Delete?id=" + `${id}`,
        //     {
        //         headers: new Headers({
        //             'Content-Type': 'application/json',
        //             'Authorization': `Bearer ${token}`,
        //         }),
        //         method: "Delete",
        //     }
        // )
        //     .then((response) => {
        //         if (response.ok) {
        //             return response.json();
        //         }
        //         throw new Error('Something went wrong');
        //     })
        //     .then((res) => {
        //         alert("Data Successfully Deleted")
        //         fetchData();
        //         setOpen(false);
        //     }).catch((error) => {
        //         console.log(error)
        //     });


    };
    const [selectedOptions, setSelectedOption] = React.useState<string[] | string>([]);
    function EditToolbar() {

        return (
            <Box
                sx={{
                    borderBottom: 1,
                    borderColor: 'divider',
                    p: 1,
                }}
            >
                <div className="row col-lg-12" style={{ marginTop: "10px" }}>

                    <div className="col-lg-4 col-md-4 col-sm-4" style={{ fontSize: "32px" }}>
                        <span className="d-flex card-title">Tax Schedule By Jurisdiction</span>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-4" >
                        <span className="card-title filter-blue" ><GridToolbarFilterButton /></span>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-4" style={{ textAlign: "right" }}>
                        <span >

                            <button
                                // style={{ marginRight: "30px", float: 'right', height: "50px" }}
                                className="btn active-btn-blue"
                                onClick={handleClickOpen}
                            >
                                Add New
                            </button>

                        </span>
                    </div>

                </div>

            </Box>
        );
    }
    const columns: GridColDef[] = [
        //  { field: 'taxScheduleByJurisdictionId', type: 'text', headerName: 'Taxing Jurisdiction' , flex: 1, headerAlign: 'center', align: 'center' },
        { field: 'taxingJurisdiction', type: 'text', headerName: 'Taxing Jurisdiction', flex: 1, headerAlign: 'center',hideSortIcons: true,
        renderHeader: (params) => (
          <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            <RiExpandUpDownLine />
          </div>
        ),  align: 'center' },
        { field: 'jurisdictionCode', type: 'text', headerName: 'Jurisdiction Code', flex: 1, headerAlign: 'center',hideSortIcons: true,
        renderHeader: (params) => (
          <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            <RiExpandUpDownLine />
          </div>
        ),  align: 'center' },
        { field: 'taxCode', type: 'text', headerName: 'Tax Code', flex: 0.8, headerAlign: 'center',hideSortIcons: true,
        renderHeader: (params) => (
          <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            <RiExpandUpDownLine />
          </div>
        ),  align: 'center' },
        { field: 'rate', type: 'number', headerName: 'Rate', flex: 0.5, headerAlign: 'center', align: 'center',hideSortIcons: true,
        renderHeader: (params) => (
          <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            <RiExpandUpDownLine />
          </div>
        ),  },
        {
            field: 'rateType', headerName: 'Rate Type', type: 'number', flex: 0.6, align: 'center',hideSortIcons: true,
            renderHeader: (params) => (
              <div>
                <span className="table-card-title" >{params.colDef.headerName}</span>
                <RiExpandUpDownLine />
              </div>
            ),  headerAlign: 'center',
            renderCell: (params) => (<div> {params.row.rateType === 0 ? "Percentage" : "Dollar"}</div>)
        },
        { field: 'minTaxFee', type: 'text', headerName: 'Min Tax Fee', flex: 0.7, headerAlign: 'center', hideSortIcons: true,
        renderHeader: (params) => (
          <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            <RiExpandUpDownLine />
          </div>
        ), align: 'center' },
        { field: 'stateName', type: 'text', headerName: 'State', flex: 0.8, headerAlign: 'center',hideSortIcons: true,
        renderHeader: (params) => (
          <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            <RiExpandUpDownLine />
          </div>
        ),  align: 'center' },
        { field: 'lineOfBusiness', type: 'text', headerName: 'LOB', flex: 1, headerAlign: 'center',hideSortIcons: true,
        renderHeader: (params) => (
          <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            <RiExpandUpDownLine />
          </div>
        ),  align: 'center' },
        { field: 'zipCode', type: 'text', headerName: 'ZipCode', flex: 0.5, headerAlign: 'center',hideSortIcons: true,
        renderHeader: (params) => (
          <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            <RiExpandUpDownLine />
          </div>
        ),  align: 'center' },

        {
            field: 'taxScheduleByJurisdictionId',
            headerName: 'Actions',
            flex: 0.5,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <div>
                    <IconButton
                        color="primary"
                        onClick={() => handleEdit(params.row)}
                    >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17 3C17.2626 2.73735 17.5744 2.52901 17.9176 2.38687C18.2608 2.24473 18.6286 2.17157 19 2.17157C19.3714 2.17157 19.7392 2.24473 20.0824 2.38687C20.4256 2.52901 20.7374 2.73735 21 3C21.2626 3.26264 21.471 3.57444 21.6131 3.9176C21.7553 4.26077 21.8284 4.62856 21.8284 5C21.8284 5.37143 21.7553 5.73923 21.6131 6.08239C21.471 6.42555 21.2626 6.73735 21 7L7.5 20.5L2 22L3.5 16.5L17 3Z" stroke="#02A4E3" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                    </IconButton>
                    {user?.userRoles.split(",").includes("Super Admin") ?
                        <IconButton
                            color="error"
                            onClick={() => { handleDelete(params.row.taxScheduleByJurisdictionId); }}

                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3 6H5M5 6H21M5 6V20C5 20.5304 5.21071 21.0391 5.58579 21.4142C5.96086 21.7893 6.46957 22 7 22H17C17.5304 22 18.0391 21.7893 18.4142 21.4142C18.7893 21.0391 19 20.5304 19 20V6H5ZM8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6" stroke="#162E3C" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </IconButton>
                        : ""}
                </div>
            ),
        },

    ];

    return (

        <div style={{ height: '75vh', width: '100%' }}>
            <DataGrid
                getRowId={(r) => r.taxScheduleByJurisdictionId}
                rows={taxesandfessCL}
                columns={columns}
                pageSize={50}
                rowsPerPageOptions={[50]}
                style={{ textAlign: 'center' }}
                components={{
                    Toolbar: EditToolbar,
                }}
                sx={
                    {
                        fontFamily: "'Proxima Nova', sans-serif",
                        border: "0px",
                        fontSize: "16px"



                    }
                }
            />

            <AddEdittaxScheduleByJurisdiction handleClose={handleClose} Open={Open} setSelectedOption={setSelectedOption} selectedOptions={selectedOptions} handleSubmit={handleSubmit} initvalues={Formdata} fetchData={fetchData} LineOfBusiness={LineOfBusiness} setLineOfBusiness={setLineOfBusiness} fetchLOBData={fetchLOBData} />

        </div>



    )
}